/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IIntegrationTemplate } from 'app/shared/model/integration-template.model';
import { IDataCategory } from 'app/shared/model/data-category.model';
import { IIntegrationChannel } from 'app/shared/model/integration-channel.model';

export interface IIntegrationTemplateCategory {
  id?: string;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  template?: IIntegrationTemplate | null;
  category?: IDataCategory | null;
  channel?: IIntegrationChannel | null;
}

export const defaultValue: Readonly<IIntegrationTemplateCategory> = {
  active: false,
};
